import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: triggered from drupal brand-specific analytics.js, to be ported

const defaultData: IDataLayer = {
  enh_action: 'social',
  event_name: 'outbound link click',
  event_category: 'outbound link click',
  event_action: null, // '<click url>'
  event_label: null // '<page url>'
};

function trackSocialClick(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('socialLink', trackSocialClick);
